import { render, staticRenderFns } from "./programDetail.vue?vue&type=template&id=69aec0c1&scoped=true"
import script from "./programDetail.vue?vue&type=script&lang=js"
export * from "./programDetail.vue?vue&type=script&lang=js"
import style0 from "./programDetail.vue?vue&type=style&index=0&id=69aec0c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aec0c1",
  null
  
)

export default component.exports